import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'Do I need prior Reiki experience to use this system?',
  answer: 'No. Volume 1 starts from complete beginner. However, this system is also valuable for experienced practitioners wanting structure and professionalism.'
}, {
  question: 'Can I use this if I’m not offering sessions commercially?',
  answer: 'Absolutely. Many people use this for personal practice, family work, and spiritual development. The system supports all levels of practice.'
}, {
  question: 'Are the resources really printable?',
  answer: 'Yes. The 60-page resource library includes session intake forms, chakra charts, meditation scripts, client assessment cards, and diagnostic maps — all ready to print and use immediately.'
}, {
  question: 'Are all 5 bonus guides really FREE?',
  answer: 'Yes. The $27 includes everything: 6 volumes + 5 bonuses + all printable resources. No upsells, no subscriptions.'
}, {
  question: 'How long do I have access?',
  answer: 'Forever. Lifetime access means once you purchase, you own the content. Download it, use it, reference it for the rest of your practice.'
}, {
  question: 'What makes this different from free resources online?',
  answer: 'This is a complete professional operating system, not scattered information. It’s organized, comprehensive, field-tested, and designed specifically to take you from practitioner to professional. Free resources don’t have this structure or depth.'
}, {
  question: 'What if it doesn’t work for me?',
  answer: 'We offer a 7-day money-back guarantee. Download everything, explore the system, and if it’s not right for you, we’ll refund you completely. Our refund rate is less than 2% because this system genuinely works.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-63" data-mp="2ku3quyhz4yut">
      <div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-64" data-mp="2fwahxxpadqqu">
        <button type="button" className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-65" data-mp="2ay90fh7idzhh">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-66" data-mp="33lwm6zkimw5p">
            ?
          </span>
          <span className="flex-1 font-semibold text-navy" data-id="element-67" data-mp="2ypef3t1pqlq7">{item.question}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-68" data-mp="2ulgibozv1n0b" />
        </button>
        <AnimatePresence initial={false} data-id="element-69" data-mp="1j501psckl0bv">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-70" data-mp="3uuppyy8d40j9">
              <p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-71" data-mp="cfx7tkrontop">
                {item.answer}
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-72" data-mp="mca0qgfem3ie">
      <div className="mx-auto max-w-3xl" data-id="element-73" data-mp="qfggqfsbj922">
        <Reveal className="text-center" data-id="element-74" data-mp="qghu4qwt47my">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-75" data-mp="vfb78i86lwml">
            ❓ Frequently Asked <span className="text-sage" data-id="element-76" data-mp="2s7bavhij6uwj">Questions</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-77" data-mp="2s95zb5t0h55d">Everything you need to know before you buy.</p>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-78" data-mp="2x88ve0r0k117">
          {faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-79" data-mp="21u4y1l5u7xk6" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}